/* eslint-disable react-hooks/exhaustive-deps */
import "./CSS/DashboardScreen.css";
import leftWhiteIcon from "../../assets/images/dashboard-left-white.svg";
import leftOrengeIcon from "../../assets/images/dashboard-left-orenge.svg";
import rightWhiteIcon from "../../assets/images/dashboard-right-white.svg";
import rightOrengeIcon from "../../assets/images/dashboard-right-orenge.svg";
import infoIcon from "../../assets/images/dashboard-info-icon.svg";
import underReviewIcon from "../../assets/images/dashboard-under-review-icon.svg";
import headerAppIcon from "../../assets/images/dashboard-header-app-icon.png";
import headerConnectIcon from "../../assets/images/dashboard-header-connect-icon.svg";
import headerRSVPLocationIcon from "../../assets/images/dashboard-rsvp-location-icon.svg";
import dashboardGreenStarIcon from "../../assets/images/dashboard-screen-green-star.svg";
import { useEffect, useRef, useState } from "react";
import DashboardScreenDetailFooter from "./Views/DashboardScreenDetailFooter";
import { useQuery } from "@tanstack/react-query";
import useWSMApi from "services/api/useWSMApi";
import BecomeMemberDialog from "components/elements/BecomeMemberDialog";
import ROUTE_PATHS from "utils/routePaths";
import { useNavigate } from "react-router-dom";
import {
  CALENDAR_RESERVATION_TYPE,
  LaunchDateCleanFuelCafe,
  LaunchDateCommunicateSpace,
  LaunchDateCreativeSpace,
  LaunchDateInnovativeSpace,
  MENU_ITEM,
  PROFILE_STATUS,
} from "utils/constants";
import { useTabBar } from "services/TabBarProvider";
import { STORAGE_KEY, WEB_LINK } from "utils/strings";
import { useStorage } from "services/StorageProvider";
import ConnectDialog from "components/elements/ConnectDialog";
import ComingUpEventsView from "./Views/ComingUpEventsView";
import cleanFuelCafeImage from "../../assets/images/member-benefits-clean-fuel-cafe.png";
import innovativeImage from "../../assets/images/member-benefits-innovative.png";
import creativeImage from "../../assets/images/member-benefits-creative.png";
import communicativeSpaceImage from "../../assets/images/member-benefits-communicative-space.png";
import cardFirstImage from "../../assets/images/dashboard-member-benefits-card-first.png";
import retreatImage from "../../assets/images/member-benefits-retreat.png";
import JoinCircleDialog from "components/elements/JoinCircleDialog";
import {
  trackHomeView,
  trackCategoryClick,
  trackItemClick,
} from "utils/analytics";
interface Benefits {
  title: string;
  buttonTitle: string;
  image: string;
}

const DashboardScreen = () => {
  const today = new Date();
  const memberBenefits: Benefits[] = [
    {
      title: "Create Space",
      buttonTitle:
        today < LaunchDateCreativeSpace
          ? "Available from 1st April"
          : "Explore",
      image: creativeImage,
    },
    {
      title: "Innovate Space",
      buttonTitle:
        today < LaunchDateInnovativeSpace
          ? "Available from 1st April"
          : "Explore",
      image: innovativeImage,
    },
    {
      title: "Communicate Space",
      buttonTitle:
        today < LaunchDateCommunicateSpace
          ? "Available from 15th April"
          : "Explore",
      image: communicativeSpaceImage,
    },
    {
      title: "Energy Space",
      buttonTitle:
        today < LaunchDateCleanFuelCafe
          ? "Available from 1st April"
          : "Explore",
      image: cleanFuelCafeImage,
    },
    {
      title: "Wellness Space",
      buttonTitle: "Coming Soon",
      image: retreatImage,
    },
  ];

  const navigate = useNavigate();
  const [isActiveMember, setIsActiveMember] = useState<boolean>(false);
  const eventsContainerRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const [showBecomeMemberDialog, setShowBecomeMemberDialog] =
    useState<boolean>(false);
  const [showConnectDialog, setShowConnectDialog] = useState<boolean>(false);
  const [showJoinCircleDialog, setShowJoinCircleDialog] =
    useState<boolean>(false);
  const { setSelectedTabBar } = useTabBar();
  const { userProfileData, refreshUserProfile } = useStorage();
  const { fetchComingUpEvents, fetchBulletinSlot, fetchReservations } =
    useWSMApi();

  const { data: bulletinSoltData } = useQuery({
    queryKey: ["fetch-bulletin-slot"],
    queryFn: () => fetchBulletinSlot(),
    retry: false,
  });

  const { data: comingUpEventsData } = useQuery({
    queryKey: ["fetch-coming-up-events"],
    queryFn: () => fetchComingUpEvents(),
    retry: false,
  });

  const { data: reservationsData, isError: reservationError } = useQuery({
    queryKey: ["fetch-user-reservations"],
    queryFn: () => fetchReservations(),
    retry: false,
  });

  useEffect(() => {
    refreshUserProfile();
    setIsActiveMember(
      userProfileData?.credit?.status === PROFILE_STATUS.MEMBER,
    );
    trackHomeView();
  }, []);

  useEffect(() => {
    const storedDeepLinkData = sessionStorage.getItem(
      STORAGE_KEY.WORKSPACE_DEEPLINK_DATA,
    );
    if (storedDeepLinkData) {
      const deepLinkData = JSON.parse(storedDeepLinkData);
      if (deepLinkData.type === CALENDAR_RESERVATION_TYPE.RETREAT) {
        navigate(
          ROUTE_PATHS.WSM_RETREAT_DETAIL.replace(":slotId", deepLinkData.id),
        );
      } else {
        navigate(
          ROUTE_PATHS.WSM_WORKSPACE_DETAIL.replace(":slotId", deepLinkData.id),
        );
      }
    }
  }, []);

  const updateScrollButtons = () => {
    const el = eventsContainerRef.current;
    if (el) {
      setCanScrollLeft(el.scrollLeft > 0);
      setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    }
  };

  useEffect(() => {
    updateScrollButtons();
    const el = eventsContainerRef.current;
    if (!el) return;
    el.addEventListener("scroll", updateScrollButtons);
    window.addEventListener("resize", updateScrollButtons);
    return () => {
      el.removeEventListener("scroll", updateScrollButtons);
      window.removeEventListener("resize", updateScrollButtons);
    };
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    script.onload = () => {
      console.log("Razorpay script loaded");
    };
    document.body.appendChild(script);
  }, []);

  const scrollEvents = (direction: "left" | "right") => {
    if (eventsContainerRef.current && isActiveMember) {
      const scrollAmount = 200;
      eventsContainerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
      setTimeout(updateScrollButtons, 300);
    }
  };

  const handleBulletinCardClick = (bulletinData: any) => {
    trackItemClick(bulletinData?.id, bulletinData?.title);
    const reservation = !reservationError
      ? reservationsData?.data?.content?.find(
        (reservation: any) =>
          reservation?.service_slot_id === bulletinData?.id,
      )
      : null;
    localStorage.setItem(
      STORAGE_KEY.SELECTED_RESERVATION_DATA,
      JSON.stringify(reservation),
    );
    localStorage.setItem(
      STORAGE_KEY.SELECTED_SLOT_DATA,
      JSON.stringify(bulletinData),
    );
    if (bulletinData.service_type === CALENDAR_RESERVATION_TYPE.RETREAT) {
      navigate(
        ROUTE_PATHS.WSM_RETREAT_DETAIL.replace(":slotId", bulletinData?.id),
      );
    } else {
      navigate(
        ROUTE_PATHS.WSM_WORKSPACE_DETAIL.replace(":slotId", bulletinData?.id),
      );
    }
  };

  const handleMemberBenefitsChange = (index: number) => {
    const categoryNames = [
      "Clean Fuel Café",
      "Innovative Space",
      "Creative Space",
      "Events",
      "Retreats",
      "Communicate Space",
      "Mind Body Studio",
      "Scaling Workshops",
    ];
    if (categoryNames[index]) {
      trackCategoryClick(categoryNames[index]);
    }
    if (index === 0) {
      navigate(ROUTE_PATHS.WSM_CALENDAR_CREATIVE_SPACE);
    } else if (index === 1) {
      navigate(ROUTE_PATHS.WSM_CALENDAR_INNOVATIVE_SPACE);
    } else if (index === 2) {
      navigate(ROUTE_PATHS.WSM_CALENDAR_COMMUNICATE_SPACE_DETAIL);
    } else if (index === 3) {
      navigate(ROUTE_PATHS.WSM_WEB_LINK_DETAIL, {
        state: {
          anyData: {
            title: "Clean Fuel Café",
            url: WEB_LINK.CLEAN_FUEL_CAFE,
          },
        },
      });
    }
  };

  const getHeaderContent = () => {
    if (
      userProfileData?.credit?.status === PROFILE_STATUS.UNDER_REVIEW
    ) {
      return (
        <>
          <button
            className="member-button"
            onClick={() => setShowBecomeMemberDialog(true)}
          >
            Step into Sabe
            <img src={underReviewIcon} alt="under-review-icon" />
          </button>
          <div className="info-container">
            <img src={infoIcon} alt="info-icon" />
            <span>
              Membership Review is{" "}
              <span style={{ color: "#C2B58C" }}>Under Way.</span>
            </span>
          </div>
        </>
      );
    } else if (
      userProfileData?.credit?.status === PROFILE_STATUS.PAYMENT_PENDING
    ) {
      return (
        <>
          <button
            className="member-button"
            style={{ backgroundColor: "#CDD7D6" }}
            onClick={() => setSelectedTabBar(MENU_ITEM.MEMBERSHIP)}
          >
            You're in .. Almost
          </button>
          <div className="info-container" style={{ width: "242px" }}>
            <img src={infoIcon} alt="info-icon" />
            <span>
              Membership Approved,{" "}
              <span style={{ color: "#C2B58C" }}>Complete your payment</span>
            </span>
          </div>
        </>
      );
    }
  };

  const handleComingUpCardClick = (event: any) => {
    const reservation = !reservationError
      ? reservationsData?.data?.content?.find(
        (reservation: any) => reservation?.service_slot_id === event?.id,
      )
      : null;
    localStorage.setItem(
      STORAGE_KEY.SELECTED_RESERVATION_DATA,
      JSON.stringify(reservation),
    );
    localStorage.setItem(STORAGE_KEY.SELECTED_SLOT_DATA, JSON.stringify(event));
    navigate(ROUTE_PATHS.WSM_WORKSPACE_DETAIL.replace(":slotId", event?.id));
  };

  return (
    <div className="wms-mobile-container">
      <div className="dashboard-screen-main-container">
        <div className="dashboard-screen-header-bar">
          <img
            src={headerAppIcon}
            alt="left-button"
            className="header-app-icon"
          />
          <div
            className="right-container"
            onClick={() => setShowConnectDialog(true)}
          >
            <img src={headerConnectIcon} alt="left-button" />
            <span>Connect</span>
          </div>
        </div>
        <div className="dashboard-screen-header-container">
          <div className="welcome-container">
            <div className="title">Hola!</div>
          </div>

          {isActiveMember ? (
            <div className="sub-title">{`${userProfileData?.first_name}`}</div>
          ) : (
            getHeaderContent()
          )}
        </div>

        {bulletinSoltData?.data?.content?.length > 0 && (
          <div className="dashboard-screen-detail-container">
            <div className="header-bar-container">
              <div className="left-conatiner">
                <span>Featured</span>
                <img src={dashboardGreenStarIcon} alt="left-button" />
              </div>
              {/* <div className="location-container">
                <img src={headerRSVPLocationIcon} alt="profile-coin-icon" />
                {bulletinSoltData?.slot_country}
              </div> */}
            </div>
            <div className="divider" />
            <div className="dashboard-screen-bulletin-container">
              {bulletinSoltData?.data?.content?.map(
                (event: any, index: number) => (
                  <div
                    className="dashboard-screen-detail-sub-container"
                    key={event?.id ?? index}
                  >
                    <div
                      className="left-container"
                      style={{
                        backgroundImage: `url(${event?.slot_image})`,
                      }}
                      onClick={() => handleBulletinCardClick(event)}
                    >
                      <div className="header-container">
                        <div className="header-bar">{event?.title}</div>
                        {event?.slot_country && (
                          <div className="location-container">
                            <img
                              src={headerRSVPLocationIcon}
                              alt="profile-coin-icon"
                            />
                            {event?.slot_country}
                          </div>
                        )}
                      </div>
                      <DashboardScreenDetailFooter
                        slotDate={event?.slot_date}
                        slotTime={event?.start_time}
                        onClickRSVP={() => handleBulletinCardClick(event)}
                      />
                    </div>
                  </div>
                ),
              )}
            </div>
          </div>
        )}

        {comingUpEventsData?.data?.content?.length > 0 && (
          <div className="dashboard-screen-coming-up-container">
            <div className="header-container">
              <span>
                coming <span style={{ color: "#C2B58C" }}>up</span>
              </span>
              <div className="button-container">
                <img
                  src={canScrollLeft ? leftOrengeIcon : leftWhiteIcon}
                  alt="left-button"
                  onClick={() => canScrollLeft && scrollEvents("left")}
                />
                <img
                  src={canScrollRight ? rightOrengeIcon : rightWhiteIcon}
                  alt="right-button"
                  onClick={() => canScrollRight && scrollEvents("right")}
                />
              </div>
            </div>
            <div className="divider"></div>
            <div className="dashboard-screen-coming-up-events-container-events-wrapper">
              <div
                className="dashboard-screen-coming-up-events-container"
                ref={eventsContainerRef}
              >
                {comingUpEventsData?.data?.content?.map(
                  (event: any, index: number) => (
                    <ComingUpEventsView
                      key={index}
                      event={event}
                      onClick={() => handleComingUpCardClick(event)}
                    />
                  ),
                )}
              </div>
            </div>
          </div>
        )}

        <div className="dashboard-screen-member-benefits-container">
          <span>3<sup className="title-text">rd </sup></span>
          <span>
            Space <span style={{ color: "#C2B58C" }}>Ecosystem</span>
          </span>
          <div className="dashboard-screen-member-benefits-list-container">
            {memberBenefits.map((benefits, index) => (
              <div key={index}>
                <div className="divider"></div>
                <div
                  key={index}
                  className="dashboard-screen-member-benefits-list-item"
                  style={{
                    backgroundImage: `url(${benefits.image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                  onClick={() => handleMemberBenefitsChange(index)}
                >
                  <div
                    className={`dashboard-screen-member-benefits-list-sub-item ${index % 2 === 0 ? "odd-card" : "even-card"
                      }`}
                  >
                    <div className="title">{benefits.title}</div>
                    <div className="btn-container">
                      <button>{benefits.buttonTitle}</button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div
          className="dashboard-screen-member-benefits-container"
          style={{ marginBottom: "80px" }}
        >
          <span>Connect</span>
          <div className="dashboard-screen-member-benefits-list-container">
            <div>
              <div className="divider"></div>
              <div
                className="dashboard-screen-member-benefits-list-item"
                style={{
                  backgroundImage: `url(${cardFirstImage})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div
                  className={`dashboard-screen-contact-item-container`}
                  onClick={() => setShowJoinCircleDialog(true)}
                >
                  <div className="title">Enter the SABE Community</div>
                  <div className="sub-title">
                    Connect with Founders and Remote Workers focused on Deep
                    Work, Clean Energy, and Intentional Growth.
                  </div>
                  <div className="btn-container">
                    <button>Join the Channel on 6th May</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BecomeMemberDialog
        profileStatus={userProfileData?.credit?.status}
        open={showBecomeMemberDialog}
        onClose={() => setShowBecomeMemberDialog(false)}
      />
      <ConnectDialog
        open={showConnectDialog}
        onClose={() => setShowConnectDialog(false)}
      />
      <JoinCircleDialog
        open={showJoinCircleDialog}
        onClose={() => setShowJoinCircleDialog(false)}
      />
    </div>
  );
};

export default DashboardScreen;
